import type { Template } from '@piccolohealth/pbs-common';
import { ChakraV3 } from '@piccolohealth/ui';
import type { Editor } from '@tiptap/react';
import React from 'react';
import { HocuspocusDebugMenu } from '../../components/tiptap/HocuspocusDebugMenu';
import type { HocuspocusState } from '../../components/tiptap/hooks/useHocuspocusProvider';
import { SaveStatusIndicator } from '../../components/tiptap/SaveStatusIndicator';
import { UserStatusIndicator } from '../../components/tiptap/UserStatusIndicator';
import { TemplateActionMenu } from './TemplateActionMenu';

interface Props {
  editor: Editor;
  template: Template;
  state: HocuspocusState;
}

export const TemplateTitleBar = (props: Props) => {
  const { editor, template, state } = props;

  return (
    <ChakraV3.Stack gap={4} mt={4}>
      <ChakraV3.HStack>
        <ChakraV3.Heading size='3xl' fontWeight='bold' lineClamp={1}>
          {template.name}
        </ChakraV3.Heading>
        <ChakraV3.Spacer />
        <ChakraV3.HStack flexShrink={0}>
          <SaveStatusIndicator state={state} />
          <UserStatusIndicator editor={editor} state={state} />
          <HocuspocusDebugMenu variant='outline' size='sm' />
          <TemplateActionMenu template={template} variant='outline' size='sm' />
        </ChakraV3.HStack>
      </ChakraV3.HStack>
    </ChakraV3.Stack>
  );
};
